import React from "react";

import {
    RiCircleLine,
    RiRadioButtonLine,
} from "@remixicon/react";
import classNames from "classnames";
import {
    DashboardTicketDisplay,
    DashboardView,
} from "../../../../__generated__/api";
import BoardLayoutKanban from "../../../../assets/img/board-layout-kanban.png";
import BoardLayoutList from "../../../../assets/img/board-layout-list.png";
import Styles from "../BoardToolbar.module.scss";

import TicketDetailsPopup from "../../../../assets/img/ticket-details-popup.png";
import TicketDetailsSide from "../../../../assets/img/ticket-details-side.png";
import Button from "../../../theme/button/Button";

export const BOARD_LAYOUT_OPTIONS = [
    {
        value: DashboardView.Kanban,
        label: "Kanban",
        image: BoardLayoutKanban,
    },
    {
        value: DashboardView.Compact,
        label: "List",
        image: BoardLayoutList,
    },
];

export const TICKET_DETAILS_OPTIONS = [
    {
        value: DashboardTicketDisplay.Modal,
        label: "Pop-up",
        image: TicketDetailsPopup,
    },
    {
        value: DashboardTicketDisplay.SideRight,
        label: "Side",
        image: TicketDetailsSide,
    },
];

type PickerType = typeof BOARD_LAYOUT_OPTIONS[number] | typeof TICKET_DETAILS_OPTIONS[number];

const SELECTED_ICON_CLASS_NAMES = classNames(Styles["radio-button"], "icon-primary", "border-primary");
const DEFAULT_ICON_CLASS_NAMES = classNames(Styles["radio-button"], "icon-secondary", "border-primary");

export default function LayoutPicker<T extends PickerType>({
    options,
    value,
    onChange,
    defaultValue,
}: {
    options: T[];
    value: T["value"] | undefined;
    defaultValue: T["value"];
    onChange: (value: T["value"]) => void
}) {
    const selected = value ?? defaultValue;
    return (
        <div className="d-flex gap3-2">
            {options.map(option => (
                <Button
                    key={option.value}
                    variant="outline-blue"
                    className={classNames(
                        "text-start p3-105 w-50",
                        selected === option.value ? "card-selected" : "card-default",
                    )}
                    onClick={() => onChange(option.value)}
                    isActive={selected === option.value}
                >
                    <div className="m3b-1">
                        {selected === option.value
                            ? <RiRadioButtonLine className={SELECTED_ICON_CLASS_NAMES} />
                            : <RiCircleLine className={DEFAULT_ICON_CLASS_NAMES} /> }
                        {option.label}
                    </div>
                    <img src={option.image} className="w-100" alt={option.label} />
                </Button>
            ))}
        </div>
    );
}
